if (!customElements.get('variant-image-carousel')) {
  class VariantImageCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-variant-image-viewport]');
      this.previousButton = this.querySelector('[data-variant-image-prev]');
      this.nextButton = this.querySelector('[data-variant-image-next]');

      if (!this.viewport) return;

      this.handlePrevious = () => this.scrollByPage(-1);
      this.handleNext = () => this.scrollByPage(1);
      this.handleScroll = () => this.updateControls();

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.viewport);

      requestAnimationFrame(() => {
        this.updateControls();
        this.revealSelectedItem(false);
      });

      this.addEventListener('change', () => {
        requestAnimationFrame(() => this.revealSelectedItem(true));
      });
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
    }

    scrollByPage(direction) {
      const firstItem = this.querySelector('.variant-image-picker__item');
      if (!firstItem || !this.viewport) return;

      const styles = getComputedStyle(this.querySelector('.variant-image-picker__track'));
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const itemWidth = firstItem.getBoundingClientRect().width + gap;
      const visibleItems = Math.max(1, Math.floor(this.viewport.clientWidth / itemWidth));
      const distance = itemWidth * Math.max(1, visibleItems - 1) * direction;

      this.viewport.scrollBy({
        left: distance,
        behavior: 'smooth'
      });
    }

    revealSelectedItem(smooth = false) {
      const selectedInput = this.querySelector('input:checked');
      const selectedItem = selectedInput?.closest('.variant-image-picker__item');
      if (!selectedItem || !this.viewport) return;

      const viewportRect = this.viewport.getBoundingClientRect();
      const itemRect = selectedItem.getBoundingClientRect();

      if (itemRect.left < viewportRect.left || itemRect.right > viewportRect.right) {
        selectedItem.scrollIntoView({
          behavior: smooth ? 'smooth' : 'auto',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }

    updateControls() {
      if (!this.viewport) return;

      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const hasOverflow = maxScroll > 3;

      this.toggleAttribute('data-no-overflow', !hasOverflow);

      if (this.previousButton) {
        this.previousButton.disabled = !hasOverflow || this.viewport.scrollLeft <= 3;
      }

      if (this.nextButton) {
        this.nextButton.disabled = !hasOverflow || this.viewport.scrollLeft >= maxScroll - 3;
      }
    }
  }

  customElements.define('variant-image-carousel', VariantImageCarousel);
}
